import { useEffect, useState } from "react";
import Reveal from "./Reveal";

export default function Portfolio({ items, sectionContent, uiStrings }) {
  const allLabel = uiStrings?.all_categories || "Todos";
  const noProjectsLabel = uiStrings?.no_projects || "Nenhum projeto nesta categoria por enquanto.";
  const [active, setActive] = useState(allLabel);

  const eyebrow = sectionContent?.eyebrow || "Portfólio";
  const headline = sectionContent?.headline || "Projetos que falam por si — em arquitetura e em marca.";

  // Dynamically extract categories from items
  const categories = [allLabel, ...new Set(items.map(i => i.category).filter(Boolean))];

  const filtered = active === allLabel ? items : items.filter((i) => i.category === active);

  return (
    <section id="portfolio" data-testid="portfolio-section" className="bg-offwhite py-28 md:py-40">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
          <Reveal className="lg:col-span-7">
            <p className="eyebrow text-warmgray">{eyebrow}</p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-softblack mt-6 leading-[1.05]">
              {headline}
            </h2>
          </Reveal>
          <Reveal delay={200} className="lg:col-span-5">
            <div className="flex flex-wrap gap-3" data-testid="portfolio-filters">
              {categories.map((c) => (
                <button
                  key={c}
                  data-testid={`portfolio-filter-${c.toLowerCase()}`}
                  onClick={() => setActive(c)}
                  className={`px-5 py-2 text-[11px] tracking-[0.28em] uppercase border transition-all duration-500 ${
                    active === c
                      ? "bg-softblack text-offwhite border-softblack"
                      : "bg-transparent text-softblack border-fendi hover:border-champagne hover:text-champagne"
                  }`}
                >
                  {c}
                </button>
              ))}
            </div>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-14" data-testid="portfolio-grid">
          {filtered.map((p, idx) => (
            <Reveal
              key={p.id}
              delay={idx * 80}
              className={`group ${idx % 3 === 1 ? "lg:mt-16" : ""}`}
            >
              <div className="relative overflow-hidden">
                <img
                  src={p.image_url}
                  alt={p.title}
                  className="w-full h-[260px] sm:h-[340px] md:h-[440px] object-cover transition-transform duration-[1600ms] group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-softblack/0 group-hover:bg-softblack/15 transition-colors duration-700" />
              </div>
              <div className="mt-4 md:mt-6 flex items-baseline justify-between gap-3 md:gap-4">
                <h3 className="font-serif text-xl sm:text-2xl text-softblack leading-snug">
                  {p.title}
                </h3>
                <span className="eyebrow text-warmgray shrink-0">{p.category}</span>
              </div>
              {p.description && (
                <p className="text-warmgray text-xs sm:text-sm leading-relaxed mt-2 md:mt-3 font-light">
                  {p.description}
                </p>
              )}
            </Reveal>
          ))}
          {filtered.length === 0 && (
            <div className="col-span-full text-center py-20 text-warmgray font-light">
              {noProjectsLabel}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
